<template>
  <div class="news-item">
    <div class="item-holder" v-if="loading">
      <div class="item-holder__img">
        <div class="item-holder__img__img holder-flashing--dark"></div>
      </div>
      <div class="item-holder__title">
        <span>
          <fa-icon :icon="{ prefix: 'far', iconName: 'clock' }" />
          ...
        </span>
        <h5 class="holder-flashing--dark"></h5>
        <h3 class="holder-flashing--dark"></h3>
      </div>
    </div>
    <b-link :to="item.id | view" v-else>
      <div class="news-img img-hover">
        <b-img :src="item.thumb" :alt="item.name" fluid-grow />
      </div>
      <div class="news-content">
        <span>{{ item.menu.name }} / {{ item.cdate.substr(0, 10) }}</span>
        <h3>{{ item.name }}</h3>
      </div>
    </b-link>
  </div>
</template>

<script>
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faClock);

Vue.component("fa-icon", FontAwesomeIcon);

export default {
  props: ["item"],
  data() {
    return {
      loading: this.$parent.loading
    };
  },
  watch: {
    data(data) {
      if (data.length > 0) {
        this.loading = this.$parent.loading;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/boots/custom_bootstrap";
.news-item {
  width: 33.33%;
  padding: 30px;
  @media (max-width: 425px) {
    width: 100%;
  }
  a {
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.15);
    background: white;
    display: block;
    font-family: $slab;
    .news-img {
      background-color: $primary;
      img {
        width: 100%;
      }
    }
    .news-content {
      padding: 10px 15px;

      .types {
        color: $primary;
      }
      h3 {
        display: inline-block;
        width: 100%;
        font-weight: 500;
        font-size: 1em;
      }
      span {
        font-size: 0.8em;
        color: $gray-light;
        display: block;
        margin-bottom: 7px;
      }
      .hashtag {
        display: inline-block;
        width: 100%;
        a {
          float: left;
          margin-right: 15px;
          font-size: 15px;
          color: $secondary;
          font-weight: bold;
          span {
            color: $primary;
          }
        }
      }

      @media (max-width: 425px) {
        h3 {
          font-size: 1rem;
        }
      }
    }

    &:hover {
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
    }
  }
  // item
  .item-holder {
    font-family: $slab;
    display: block;
    &__img {
      &__img {
        width: 100%;
        height: 205.13px;
        position: relative;
        background-color: #f6f6f6;
        font-weight: 900;
        &::after {
          content: "ЗУРАГ";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: rgba(#000, 0.1);
          font-family: $slab;
          font-size: 16px;
        }

        @media (max-width: 425px) {
          height: 110.98px;
        }
      }
    }
    &__title {
      width: 100%;
      padding: 10px;
      h5 {
        min-height: 18px;
        width: 40%;
        margin-bottom: 9px;
      }
      h3 {
        min-height: 18px;
        width: 100%;
        margin-bottom: 7px;
      }
      h3:nth-child(odd) {
        width: 70%;
      }
      span {
        font-size: 0.9em;
        color: $gray-light;
      }
      @media (max-width: 425px) {
        h5 {
          min-height: 12px;
        }
        h3 {
          min-height: 12px;
        }
      }
    }
  }
  // @media (max-width: 425px) {
  //   margin-bottom: 15px;
  // }
}
</style>
